<template>
  <v-container fluid>
    <div class="d-flex flex-row flex-grow-1">
      <PageTitle class=" font d-flex flex-row ml-2" text="Customers" />
      <div>
        <v-text-field
          dense
          append-icon="search"
          light
          single-line
          v-model="search"
          style="min-width: 500px;"
          solo-inverted
          placeholder="Search by customer name  ..."
          class="mt-2 font font-size-sm black--text"
          hide-details
          flat
        />
      </div>
    </div>
    <div class="buttonText ml-1" id="result">
      <v-btn
        v-ripple="{ class: 'primary--text' }"
        color="primary"
        class="font ml-2 mt-3 white--text font-size-sm"
        :to="{ name: 'master.customers.new' }"
      >
        <span class=" font-size-sm">Add New Customer</span>
        <v-icon size="20" class="font-size-sm" color="white">mdi-plus</v-icon>
      </v-btn>

      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            @click="refreshCustomerList"
            v-on="on"
            fab
            icon
            small
            color="primary"
            class="mt-3 ml-4"
          >
            <i class="material-icons-outlined">refresh</i>
          </v-btn>
        </template>
        <span class="font font-weight-medium">Load Update</span>
      </v-tooltip>

      <h4
        style="margin-top: 20px; margin-left: 10px"
        class=" font blue-grey--text"
      >
        List Of Business Customers
      </h4>
    </div>
    <v-row align="center" justify="center">
      <v-col cols="12">
        <v-data-table
          class="box-shadow-light  font font-weight-medium"
          :items="filteredBusinesses"
          :loading="isListLoading"
          :server-items-length="paginate.businesses.total"
          :search="search"
          :options.sync="options.businesses"
          :headers="
            headers.business.filter(title => title.value !== 'category')
          "
          :footer-props="{
            itemsPerPageOptions: [10, 20, 30]
          }"
        >
          <template #item.name="{item}">
            <v-chip color="primary" small label>
              <span class="font font-weight-medium">{{ item.name }}</span>
            </v-chip>
          </template>
          <template #item.email="{item}">
            <v-chip @click="openMail(item)" small label class="cursor-pointer">
              <span class="font font-weight-medium">{{ item.email }}</span>
            </v-chip>
          </template>
          <template #item.directors="{item}">
            <v-chip color="primary" small label>
              <span class="font font-weight-medium">{{
                item.directors.length
              }}</span>
            </v-chip>
          </template>
          <template #item.amount="{item}">
            <v-chip label color="primary" small>
              <span class=" font font-weight-medium">{{
                item.amount
                  | currencyFormat(
                    currency && currency.length > 0 ? currency[0].code : "GHS"
                  )
              }}</span>
            </v-chip>
          </template>

          <template #item.actions="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="
                    open('edit', 'customers/details', {
                      id: item.id,
                      type: 'customer-business'
                    })
                  "
                  small
                  :disabled="dialog('edit')"
                  fab
                  color="primary"
                  icon
                >
                  <i class="material-icons-outlined font-size-sm">edit</i>
                </v-btn>
              </template>
              <span class=" ft font-weight-medium">Edit Customer</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="openPDF(item)"
                  small
                  fab
                  :disabled="item.form3Upload === null"
                  color="primary"
                  icon
                >
                  <i class="material-icons-outlined font-size-sm"
                    >picture_as_pdf</i
                  >
                </v-btn>
              </template>
              <span class=" ft font-weight-medium">View attached docs</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="
                    open('details', 'customers/details', {
                      id: item.id,
                      type: 'customer-business'
                    })
                  "
                  small
                  fab
                  :disabled="dialog('details')"
                  color="primary"
                  icon
                >
                  <i class="material-icons-outlined font-size-sm">assignment</i>
                </v-btn>
              </template>
              <span class=" ft font-weight-medium">View Customer Details</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <div>
      <h4
        style="margin-top: 20px; margin-left: 10px"
        class=" font blue-grey--text"
      >
        List Of Individual Customers
      </h4>
    </div>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="filteredIndividuals"
          :loading="isListLoading"
          :headers="headers.individuals"
          :server-items-length="paginate.individuals.total"
          :search="search"
          :options.sync="options.individuals"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 30]
          }"
          class="font font-weight-medium box-shadow-light"
        >
          <template #item.amount="{item}">
            <v-chip label color="primary" small>
              <span class=" font font-weight-medium">{{
                item.amount
                  | currencyFormat(
                    currency && currency.length > 0 ? currency[0].code : "GHS"
                  )
              }}</span>
            </v-chip>
          </template>
          <template #item.email="{item}">
            <v-chip @click="openMail(item)" small label class="cursor-pointer">
              <span class="font font-weight-medium">{{ item.email }}</span>
            </v-chip>
          </template>
          <template #item.actions="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="
                    open('add', 'customers/details', {
                      id: item.id,
                      type: 'customers'
                    })
                  "
                  small
                  fab
                  :disabled="dialog('details')"
                  color="primary"
                  icon
                >
                  <i class="material-icons-outlined font-size-sm">edit</i>
                </v-btn>
              </template>
              <span class="font font-weight-medium font-size-sm"
                >Edit Customer</span
              >
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <div>
      <h4
        style="margin-top: 20px; margin-left: 10px"
        class=" font blue-grey--text"
      >
        List Of Suppliers
      </h4>
    </div>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :items="filteredSuppliers"
          :loading="isListLoading"
          :headers="[
            ...headers.business.filter(
              header =>
                header.value !== 'directors' &&
                header.value !== 'amount' &&
                header.value !== 'actions'
            ),
            { text: 'Credit Purchases Amt.', value: 'creditPurchasesAmount' },
            { text: 'Actions.', value: 'actions' }
          ]"
          :server-items-length="supplierPaginate.total"
          :search="search"
          :options.sync="options.suppliers"
          :footer-props="{
            itemsPerPageOptions: [10, 20, 30]
          }"
          class="font font-weight-medium box-shadow-light"
        >
          <template #item.category="{item}">
            <v-chip color="primary" small label>
              <span class="font font-weight-medium">{{
                item.category ? item.category : "N/A"
              }}</span>
            </v-chip>
          </template>
          <template #item.creditPurchasesAmount="{item}">
            <v-chip label color="primary" small>
              <span class=" font font-weight-medium">{{
                item.creditPurchasesAmount
                  | currencyFormat(
                    currency && currency.length > 0 ? currency[0].code : "GHS"
                  )
              }}</span>
            </v-chip>
          </template>
          <template #item.email="{item}">
            <v-chip @click="openMail(item)" small label class="cursor-pointer">
              <span class="ft font-weight-medium">{{ item.email }}</span>
            </v-chip>
          </template>
          <template #item.actions="{item}">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="open('edit', 'suppliers/details', { id: item.id })"
                  small
                  :disabled="dialog('edit')"
                  fab
                  color="primary"
                  icon
                >
                  <i class="material-icons-outlined font-size-sm">edit</i>
                </v-btn>
              </template>
              <span class=" ft font-weight-medium">Edit Supplier</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="
                    openPDF({ form3Upload: item.businessRegistrationCert })
                  "
                  small
                  fab
                  :disabled="item.businessRegistrationCert === null"
                  color="primary"
                  icon
                >
                  <i class="material-icons-outlined font-size-sm"
                    >picture_as_pdf</i
                  >
                </v-btn>
              </template>
              <span class=" ft font-weight-medium">View attached docs</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  @click="
                    open('details', 'suppliers/details', {
                      id: item.id
                    })
                  "
                  small
                  fab
                  :disabled="dialog('details')"
                  color="primary"
                  icon
                >
                  <i class="material-icons-outlined font-size-sm">assignment</i>
                </v-btn>
              </template>
              <span class=" ft font-weight-medium">View Customer Details</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <DetailsDrawerDialog
      :state="dialog('details')"
      @close="close"
      :details="details"
      @openMail="openMail"
    />
    <EditDetailsDrawerDialog
      :state="dialog('edit')"
      @close="close"
      :detailsLoading="isSubLoading"
      :loading="loading"
      @updateCustomer="updateCustomer"
      :currency="currency"
      :details="details"
    />
    <EditIndividualCustomer
      :details="details"
      :state="dialog('add')"
      :loading="loading"
      :detailsLoading="isSubLoading"
      @close="close"
      :cards="cards"
      @editCustomer="editIndividualCustomer"
    />
    <SnackBar
      :showSnackBar="showSnackBar"
      :message="message"
      :status="status"
    />
  </v-container>
</template>
<script>
import { mapGetters } from "vuex";
import DialogMixins from "../../mixins/DialogMixins";
import SnackBarMixins from "../../mixins/SnackBarMixins";
import { currencyFormat } from "../../filters/currencyFormat";
export default {
  name: "CustomerIndex",
  components: {
    PageTitle: () => import(`../../components/PageTitle`),
    DetailsDrawerDialog: () => import(`./dialogs/DetailsDrawerDialog`),
    EditDetailsDrawerDialog: () => import(`./dialogs/EditDetailsDrawerDialog`),
    SnackBar: () => import(`../../components/SnackBar`),
    EditIndividualCustomer: () => import(`./dialogs/EditIndividualCustomer`)
  },
  filters: {
    currencyFormat
  },
  computed: {
    ...mapGetters({
      isListLoading: "getIsListLoading",
      isSubLoading: "getIsSubLoading",
      paginate: "customers/getPagination",
      individuals: "customers/getIndividualCustomers",
      businesses: "customers/getBusinessCustomers",
      suppliers: "suppliers/getListOfSuppliers",
      supplierPaginate: "suppliers/getPagination",
      details: "customers/getCustomerDetails",
      currency: "currency/getSystemCurrency",
      loading: "getIsLoading",
      cards: "customers/getIDCardList"
    }),
    filteredIndividuals() {
      return this.individuals.filter(individual => {
        return (
          individual?.name?.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    },
    filteredBusinesses() {
      return this.businesses.filter(business => {
        return (
          business?.name?.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    },
    filteredSuppliers() {
      return this.suppliers.filter(supplier => {
        return (
          supplier?.name?.toLowerCase().indexOf(this.search.toLowerCase()) !==
          -1
        );
      });
    }
  },
  mixins: [DialogMixins, SnackBarMixins],
  data() {
    return {
      headers: {
        business: [
          {
            text: "Reg. No.",
            value: "businessRegistrationNumber"
          },
          {
            text: "Name",
            value: "name"
          },
          {
            text: " Email",
            value: "email"
          },

          {
            text: "Contact",
            value: "contact"
          },
          {
            text: "No. Of Directors",
            value: "directors"
          },
          {
            text: "Category",
            value: "category"
          },
          {
            text: "Bal./Amount",
            value: "amount"
          },
          {
            text: "Actions",
            value: "actions"
          }
        ],
        individuals: [
          {
            text: "Name",
            value: "name"
          },
          {
            text: " Email",
            value: "email"
          },

          {
            text: "Contact",
            value: "phone"
          },
          {
            text: "Bal./Amount",
            value: "amount"
          },
          {
            text: "Residential Address",
            value: "residentAddress"
          },
          {
            text: "Actions",
            value: "actions"
          }
        ]
      },
      options: {
        businesses: {},
        individuals: {},
        suppliers: {}
      },
      search: ""
    };
  },
  watch: {
    "options.businesses"(payload) {
      const { itemsPerPage, page } = payload;
      this.$store.dispatch("customers/listBusinesses", {
        page: page,
        limit: itemsPerPage,
        filters: this.filters?.join(",")
      });
    },
    "options.individuals"(payload) {
      const { itemsPerPage, page } = payload;
      this.$store.dispatch("customers/listIndividuals", {
        page: page,
        limit: itemsPerPage,
        filters: this.filters?.join(",")
      });
    },
    "options.suppliers"(payload) {
      const { itemsPerPage, page } = payload;
      this.$store.dispatch("suppliers/list", {
        page,
        limit: itemsPerPage,
        isPaginated: true
      });
    }
  },
  methods: {
    openMail({ email }) {
      this.openURL(`mailto:${email}`);
    },
    refreshCustomerList() {
      const { businesses, individuals } = this.paginate;
      this.$store.dispatch("customers/listBusinesses", {
        page: businesses.page,
        limit: businesses.limit
      });
      this.$store.dispatch("customers/listIndividuals", {
        page: individuals.page,
        limit: individuals.limit
      });
      this.$store.dispatch("suppliers/list", {
        isPaginated: true,
        page: this.supplierPaginate.page,
        limit: this.supplierPaginate.limit
      });
    },
    openPDF(pdf) {
      if (pdf?.form3Upload) {
        const url = `${process.env.VUE_APP_BASE.replace(
          process.env.NODE_ENV === "production" ? "/v1" : "/api/v1",
          ""
        )}/static/${pdf.form3Upload}`;
        this.openURL(url);
      }
    },
    openURL(url) {
      window.open(url, "_blank");
      window.focus();
    },
    updateCustomer(payload) {
      if (payload.businessRegistrationNumber && payload.directors) {
        const {
          id,
          areaOfTradeOrSupply,
          // eslint-disable-next-line no-unused-vars
          creditPurchasesAmount,
          natureOfBusiness,
          ...rest
        } = payload;
        this.$store.dispatch("customers/updateAsBusiness", {
          id,
          body: {
            ...rest,
            natureOfBusiness: natureOfBusiness
              ? natureOfBusiness
              : areaOfTradeOrSupply
          }
        });
      } else {
        // eslint-disable-next-line no-unused-vars
        const { id, businessRegistrationCert, amount, ...rest } = payload;
        this.$store.dispatch("suppliers/update", { id, body: rest });
      }
    },
    editIndividualCustomer(payload) {
      const { id, ...rest } = payload;
      this.$store.dispatch("customers/updateAsIndividual", { id, body: rest });
    }
  },
  created() {
    let payload = {
      page: 1,
      limit: 10,
      filters: [].join(",")
    };
    this.$store.dispatch("customers/listBusinesses", payload);
    this.$store.dispatch("customers/listIndividuals", payload);
    this.$store.dispatch("suppliers/list", { isPaginated: true, ...payload });
    this.$store.dispatch("currency/getSystemCurrency");
    this.$store.dispatch("customers/cardList");
  }
};
</script>
